import { useState } from "react";
import { API_ENDPOINT } from "../../../utils";
import axios from "axios";

const ReasoningBody = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    } else {
      console.log("No file selected.");
    }
  };
  const [inputPrompt, setInputPrompt] = useState("");
  const [chatHistory, setChatHistory] = useState(
    "You can upload jpeg as well as png images."
  );
  const [question, setQuestion] =
    useState(` Our AI tools help students understand better, improve their
            learning.`);
            
  const handleSendPrompt = async () => {
    if (file) {
      setQuestion(file.name);
      setInputPrompt("");
      setChatHistory("Generating Response...");
      const formData = new FormData();
      formData.append("text", inputPrompt);
      if (file) {
        formData.append("image", file);
      } else {
        console.error("Image is not selected or is null.");
      }
      try {
        const res = await axios.post(API_ENDPOINT.AIREASONING, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        setChatHistory(res.data.response);
      } catch (error) {
        setChatHistory(
          "Sorry, we can't process your request at the moment. Please try again later."
        );
      } finally {
        setInputPrompt("");
      }
    } else {
      setChatHistory("Image not provided or incorrect format");
    }
  };
  return (
    <section className="aira-chat">
      <div className="chat-index">
        <div className="bdrs28 ts03 ad-block">
          <div className="ad-block__inner">
            <h3 className="fz28 ff-inter text-white fw600">
              8/10 Free Generations
            </h3>
            <button className="fw500 fz14 border-0 btn btn-solid btn-solid--orange">
              Upgrade
            </button>
          </div>
        </div>
        <div className="bdrs28 chat-history">
          <div className="mb-0 title-992">
            <h5 className="fw900 fz24">History</h5>
            <button className="btn btn-round btn-round--green js-close-btn">
              <img src="./assets/images/Group.png" alt="" />
            </button>
          </div>
          <div className="bdrs21 chat-history__green-block">
            <ul className="list-inline">
              <li>
                <a href="#today" className="">
                  Today
                </a>
              </li>
              <li>
                <a href="#days7" className="">
                  7 days
                </a>
              </li>
              <li>
                <a href="#days30" className="">
                  30 days
                </a>
              </li>
            </ul>
          </div>
          <div className="chat-history__list">
            <section id="today" className="history-group today-group">
              <p className="fz10 text-uppercase fw500 mb-2 ms-3">Today</p>
              <ul className="list-unstyled mb-4">
                <li>
                  <div className="history-info selected">
                    <h6 className="fw500">
                      Lorem Ipsum&nbsp;is simply dummy text of the printing
                    </h6>
                    <p className="fz10 fw500">02:20 AM, 03-Nov</p>
                  </div>
                </li>
              </ul>
            </section>
            <section id="days7" className="history-group days7-group">
              <p className="fz10 text-uppercase fw500 mb-2 ms-3">7 days</p>
              <ul className="list-unstyled mb-4">
                <li>
                  <a href="#" className="history-info">
                    <h6 className="fw500">
                      Lorem Ipsum&nbsp;is simply dummy text of the printing
                    </h6>
                    <p className="fz10 fw500">02:20 AM, 03-Nov</p>
                  </a>
                </li>
              </ul>
            </section>
            <section id="days30" className="history-group days30-group">
              <p className="fz10 text-uppercase fw500 mb-2 ms-3">30 days</p>
              <ul className="list-unstyled mb-0">
                <li>
                  <a href="#" className="history-info">
                    <h6 className="fw500">
                      Lorem Ipsum&nbsp;is simply dummy text of the printing
                    </h6>
                    <p className="fz10 fw500">02:20 AM, 03-Nov</p>
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <div className="bdrs30 chat-area">
        <div className="title-row">
          <div className="title-row__left">
            <h2 className="fw900 fz28 text-white">Reasoning</h2>
            <p className="fw500 mb-0 fz16">
              Lorem Ipsum&nbsp;is simply dummy text of the printing.
            </p>
          </div>
          <div className="title-row__right">
            <button className="btn btn-solid bdrs20 btn-solid--orange">
              <img
                src="./assets/images/inner-pages/icons/icon-new-chat.svg"
                alt=""
              />
              <span className="fw500 fz20">New chat</span>
            </button>
            <button className="btn btn-round btn-round--actions js-history-btn hide-above-768">
              <img
                src="./assets/images/inner-pages/icons/icon-history-aira-chat.svg"
                alt=""
              />
            </button>
          </div>
        </div>
        <div className="bdrs20 user-row">
          <img
            src="./assets/images/inner-pages/icons/icon-nav-user.svg"
            alt=""
          />
          <p className="mb-0 text-white ff1 fz18 fw500 ">{question}</p>
          <button className="ms-auto btn btn-round btn-round--edit">
            <img src="./assets/images/inner-pages/icons/icon-edit.svg" alt="" />
          </button>
        </div>
        <div className="reply-area">
          <div className="bdrs30 reply-area__top">
            <div className="rounded-circle logo-left">
              <img src="./assets/images/Group.png" alt="" />
            </div>
            <div className="text-content">{chatHistory}</div>
          </div>
          <div className="bdrs30 reply-area__bottom">
            <div className="bdrs30 actions">
              <ul className="list-inline">
                <li>
                  <button className="btn btn-round btn-round--actions">
                    <img
                      src="./assets/images/inner-pages/icons/icon-speaker.svg"
                      alt=""
                    />
                  </button>
                </li>
                <li>
                  <button className="btn btn-round btn-round--actions">
                    <img
                      src="./assets/images/inner-pages/icons/icon-copy.svg"
                      alt=""
                    />
                  </button>
                </li>
                <li>
                  <button className="btn btn-round btn-round--actions">
                    <img
                      src="./assets/images/inner-pages/icons/icon-thumbs-up.svg"
                      alt=""
                    />
                  </button>
                </li>
                <li>
                  <button className="btn btn-round btn-round--actions">
                    <img
                      src="./assets/images/inner-pages/icons/icon-thumbs-down.svg"
                      alt=""
                    />
                  </button>
                </li>
              </ul>
              <span className="ff1 num-count">1200</span>
            </div>
            <div className="cta-regenrate">
              <button className="btn btn-solid btn-solid--limegreen">
                <img
                  src="./assets/images/inner-pages/icons/icon-refresh.svg"
                  alt=""
                />
                <span className="ff2 fz14 text-nowrap fw500">
                  Regenerate Response
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className=" send-message-row">
          <div className="position-relative form-group">
            <img
              src="./assets/images/inner-pages/icons/icon-keyboard.svg"
              alt=""
              className="position-absolute icon-keyboard"
            />
            <input
              onChange={(e) => setInputPrompt(e.target.value)}
              type="text"
              value={inputPrompt}
              className="border-0 form-control fz16"
              placeholder="Ask me something..."
            />
            <div className="position-absolute file-attach">
              <input
                type="file"
                name="file"
                id=""
                accept=".jpeg, .jpg, .png"
                onChange={handleFileChange}
              />
              <img
                src="./assets/images/inner-pages/icons/icon-file-attachment.svg"
                alt=""
                className=" "
              />
            </div>
          </div>
          <button className="btn btn-round btn-round--white">
            <img src="./assets/images/inner-pages/icons/icon-mic.svg" alt="" />
          </button>
          <button
            onClick={() => {
              handleSendPrompt();
            }}
            className="btn btn-round btn-round--orange"
          >
            <img src="./assets/images/inner-pages/icons/icon-send.svg" alt="" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ReasoningBody;
